//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterDocumentTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterDocumentType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-document-type/detail', {'params':params});
	};

	//GeneratorFlag:[LetterDocumentType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-document-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}